<template>
	<div class="el-dialog-body-spacing">
		<el-dialog title="修改手机号" :model-value="dialogVisible" width="600px" :before-close="hideDialog"
			:close-on-click-modal='false' append-to-body>
			<div style="position: relative">
				<el-form :model="pushData" :rules="rules" ref="formBox" label-width="120px">
					<el-form-item label="原手机号" prop="phoneNumber">
						<el-input v-model="pushData.phoneNumber" disabled style="width: 85%"></el-input>
					</el-form-item>
					<el-form-item label="新手机号" prop="newPhoneNumber">
						<el-input v-model="pushData.newPhoneNumber" placeholder="请输入手机号" style="width: 85%"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="hideDialog">取 消</el-button>	
					<el-button color='#112DF2' type="primary" @click="confirm">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script>
	import Validate from '@/utils/rules'
	import {employeeUpdatePhoneNumberById} from '@/api'
	export default {
		props: {
			visiFlag: {
				type: Function,
				default: function() {}
			},
			recordObject:{
				type:Object,
				default:{}
			},
			dialogVisible: {
				type: Boolean,
				default: false
			},
		},
		data() {	
			return {
				pushData:{
					phoneNumber:'',
					newPhoneNumber:''
				},
				rules: {
					phoneNumber: [{required: true}],
					newPhoneNumber: [{required: true,message: "请输入正确手机号",validator: Validate.isTel, trigger: "blur"}]
				},
				isRefresh:false
			}
		},
		watch: {
			dialogVisible(v) {
				this.pushData = {
					phoneNumber:'',
					newPhoneNumber:''
				}
				if (v) {
					this.pushData.id = ''
					if (Object.keys(this.recordObject).length) {
						for (let key in this.pushData) {
							this.pushData[key] = this.recordObject[key]
						}
					}
				}
			}
		},
		methods: {
			confirm(){
				this.$refs.formBox.validate((valid) => {
					if (valid) {
						let data = {
							id : this.pushData.id,
							phoneNumber : this.pushData.newPhoneNumber
						}
						employeeUpdatePhoneNumberById({data}).then(res=>{
							if(res.success){
								this.isRefresh = true
								this.hideDialog()
							}else{
								this.loading = false
								this.$message.error(res.msg)
							}
						})
						
					}
				})
			},
			hideDialog() {
				this.visiFlag(false, this.isRefresh)
			}
		}
	}
</script>
<style rel="stylesheet/scss" lang='scss' scoped>
	.el-dialog__body{
		overflow: hidden;
		overflow-y:auto;
	}	
</style>
